import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";



function Booking() {
  return (
    <main class="wrap_" style={{padding:'10px',backgroundImage:'url(./images/bg_.webp)',backgroundSize:'cover',backgroundAttachment:'fixed',width:'100%',margin:'0px'}}>
    {/* <h1>8‑Icon Box — Icon Hover Animation</h1>
    <p class="lead">Hover or focus each card to see an icon-centric animation: lift, rotate, ring and sparkle. Keyboard accessible and responsive.</p> */}

    <section class="grid" aria-label="Icon features">

      {/* <!-- 1 --> */}
      <Link to="https://booking.sreepadmanabhaswamytemple.org/">
      <article class="card" tabindex="0" aria-labelledby="title-1">
        
        <div class="ring" aria-hidden></div>
        <div class="spark one" aria-hidden></div>
        <div class="icon-wrap_" aria-hidden>
          {/* <!-- compass --> */}
          {/* <!-- <svg viewBox="0 0 24 24" fill="none" aria-hidden><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z" stroke="white" stroke-width="1.2" opacity="0.9"></path><path d="M9 15l6-3-3-6-6 3 3 6z" fill="white" opacity="0.95"></path></svg> --> */}
          <img src="./images/booking.png" alt="Online Booking" Style={{width:'100%'}} />
        </div>
         <h6 style={{color:'maroon',zIndex:'999',fontWeight:'600'}}>Prathishta 01</h6>
        <div class="label" id="title-1" style={{color:'white'}}>Book Now</div>
        {/* <span class="sr-only">Discover — Align on problems</span> */}
        
      </article>
      </Link>
      <Link to="https://booking.sreepadmanabhaswamytemple.org/">
      <article class="card" tabindex="0" aria-labelledby="title-1">
        
        <div class="ring" aria-hidden></div>
        <div class="spark one" aria-hidden></div>
        <div class="icon-wrap_" aria-hidden>
          {/* <!-- compass --> */}
          {/* <!-- <svg viewBox="0 0 24 24" fill="none" aria-hidden><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z" stroke="white" stroke-width="1.2" opacity="0.9"></path><path d="M9 15l6-3-3-6-6 3 3 6z" fill="white" opacity="0.95"></path></svg> --> */}
          <img src="./images/booking.png" alt="Online Booking" Style={{width:'100%'}} />
        </div>
         <h6 style={{color:'maroon',zIndex:'999',fontWeight:'600'}}>Prathishta 02</h6>
        <div class="label" id="title-1" style={{color:'white'}}>Book Now</div>
        {/* <span class="sr-only">Discover — Align on problems</span> */}
        
      </article>
      </Link>
      <Link to="https://booking.sreepadmanabhaswamytemple.org/">
      <article class="card" tabindex="0" aria-labelledby="title-1">
        
        <div class="ring" aria-hidden></div>
        <div class="spark one" aria-hidden></div>
        <div class="icon-wrap_" aria-hidden>
          {/* <!-- compass --> */}
          {/* <!-- <svg viewBox="0 0 24 24" fill="none" aria-hidden><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z" stroke="white" stroke-width="1.2" opacity="0.9"></path><path d="M9 15l6-3-3-6-6 3 3 6z" fill="white" opacity="0.95"></path></svg> --> */}
          <img src="./images/booking.png" alt="Online Booking" Style={{width:'100%'}} />
        </div>
         <h6 style={{color:'maroon',zIndex:'999',fontWeight:'600'}}>Prathishta 03</h6>
        <div class="label" id="title-1" style={{color:'white'}}>Book Now</div>
        {/* <span class="sr-only">Discover — Align on problems</span> */}
        
      </article>
      </Link>
       <Link to="https://booking.sreepadmanabhaswamytemple.org/">
      <article class="card" tabindex="0" aria-labelledby="title-1">
        
        <div class="ring" aria-hidden></div>
        <div class="spark one" aria-hidden></div>
        <div class="icon-wrap_" aria-hidden>
          {/* <!-- compass --> */}
          {/* <!-- <svg viewBox="0 0 24 24" fill="none" aria-hidden><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z" stroke="white" stroke-width="1.2" opacity="0.9"></path><path d="M9 15l6-3-3-6-6 3 3 6z" fill="white" opacity="0.95"></path></svg> --> */}
          <img src="./images/booking.png" alt="Online Booking" Style={{width:'100%'}} />
        </div>
         <h6 style={{color:'maroon',zIndex:'999',fontWeight:'600'}}>Prathishta 04</h6>
        <div class="label" id="title-1" style={{color:'white'}}>Book Now</div>
        {/* <span class="sr-only">Discover — Align on problems</span> */}
        
      </article>
      </Link>
       <Link to="https://booking.sreepadmanabhaswamytemple.org/">
      <article class="card" tabindex="0" aria-labelledby="title-1">
        
        <div class="ring" aria-hidden></div>
        <div class="spark one" aria-hidden></div>
        <div class="icon-wrap_" aria-hidden>
          {/* <!-- compass --> */}
          {/* <!-- <svg viewBox="0 0 24 24" fill="none" aria-hidden><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z" stroke="white" stroke-width="1.2" opacity="0.9"></path><path d="M9 15l6-3-3-6-6 3 3 6z" fill="white" opacity="0.95"></path></svg> --> */}
          <img src="./images/booking.png" alt="Online Booking" Style={{width:'100%'}} />
        </div>
         <h6 style={{color:'maroon',zIndex:'999',fontWeight:'600'}}>Prathishta 05</h6>
        <div class="label" id="title-1" style={{color:'white'}}>Book Now</div>
        {/* <span class="sr-only">Discover — Align on problems</span> */}
        
      </article>
      </Link>
      {/* <!-- 2 --> */}
      <Link to="timing">
      <article class="card" tabindex="0" aria-labelledby="title-1">
        
        <div class="ring" aria-hidden></div>
        <div class="spark one" aria-hidden></div>
        <div class="icon-wrap_" aria-hidden>
          {/* <!-- compass --> */}
          {/* <!-- <svg viewBox="0 0 24 24" fill="none" aria-hidden><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z" stroke="white" stroke-width="1.2" opacity="0.9"></path><path d="M9 15l6-3-3-6-6 3 3 6z" fill="white" opacity="0.95"></path></svg> --> */}
          <img src="./images/darshan-timing.png" alt="Darsan Timings" Style={{width:'100%'}} />
        </div>
         <h6 style={{color:'maroon',zIndex:'999',fontWeight:'600'}}>Prathishta 06</h6>
        <div class="label" id="title-1" style={{color:'white'}}>View</div>
        {/* <span class="sr-only">Discover — Align on problems</span> */}
        
      </article>
      </Link>

      {/* <!-- 3 --> */}
      <Link to="attract">
      <article class="card" tabindex="0" aria-labelledby="title-1">
        
        <div class="ring" aria-hidden></div>
        <div class="spark one" aria-hidden></div>
        <div class="icon-wrap_" aria-hidden>
          {/* <!-- compass --> */}
          {/* <!-- <svg viewBox="0 0 24 24" fill="none" aria-hidden><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z" stroke="white" stroke-width="1.2" opacity="0.9"></path><path d="M9 15l6-3-3-6-6 3 3 6z" fill="white" opacity="0.95"></path></svg> --> */}
          <img src="./images/attraction.png" alt="Attractions" Style={{width:'100%'}} />
        </div>
         <h6 style={{color:'maroon',zIndex:'999',fontWeight:'600'}}>Prathishta 07</h6>
        <div class="label" id="title-1" style={{color:'white'}}>View</div>
        {/* <span class="sr-only">Discover — Align on problems</span> */}
        
      </article>
      </Link>

      {/* <!-- 4 --> */}
      <Link to="https://booking.sreepadmanabhaswamytemple.org/otherofferings.aspx">
      <article class="card" tabindex="0" aria-labelledby="title-1">
        
        <div class="ring" aria-hidden></div>
        <div class="spark one" aria-hidden></div>
        <div class="icon-wrap_" aria-hidden>
          {/* <!-- compass --> */}
          {/* <!-- <svg viewBox="0 0 24 24" fill="none" aria-hidden><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z" stroke="white" stroke-width="1.2" opacity="0.9"></path><path d="M9 15l6-3-3-6-6 3 3 6z" fill="white" opacity="0.95"></path></svg> --> */}
          <img src="./images/annadanam.png" alt="annadanam Booking" Style={{width:'100%'}} />
        </div>
         <h6 style={{color:'maroon',zIndex:'999',fontWeight:'600'}}>Prathishta 08</h6>
        <div class="label" id="title-1" style={{color:'white'}}>View</div>
        {/* <span class="sr-only">Discover — Align on problems</span> */}
        
      </article>
      </Link>

      {/* <!-- 5 --> */}
      <Link to="https://booking.sreepadmanabhaswamytemple.org/otherofferings.aspx">
      <article class="card" tabindex="0" aria-labelledby="title-1">
        
        <div class="ring" aria-hidden></div>
        <div class="spark one" aria-hidden></div>
        <div class="icon-wrap_" aria-hidden>
          {/* <!-- compass --> */}
          {/* <!-- <svg viewBox="0 0 24 24" fill="none" aria-hidden><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z" stroke="white" stroke-width="1.2" opacity="0.9"></path><path d="M9 15l6-3-3-6-6 3 3 6z" fill="white" opacity="0.95"></path></svg> --> */}
          <img src="./images/e-kanikka.png" alt="kanikka Booking" Style={{width:'100%'}} />
        </div>
         <h6 style={{color:'maroon',zIndex:'999',fontWeight:'600'}}>Prathishta 09</h6>
        <div class="label" id="title-1" style={{color:'white'}}>Donate</div>
        {/* <span class="sr-only">Discover — Align on problems</span> */}
        
      </article>
      </Link>

      {/* <!-- 6 --> */}
     <Link to="/">
      <article class="card" tabindex="0" aria-labelledby="title-1">
        
        <div class="ring" aria-hidden></div>
        <div class="spark one" aria-hidden></div>
        <div class="icon-wrap_" aria-hidden>
          {/* <!-- compass --> */}
          {/* <!-- <svg viewBox="0 0 24 24" fill="none" aria-hidden><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z" stroke="white" stroke-width="1.2" opacity="0.9"></path><path d="M9 15l6-3-3-6-6 3 3 6z" fill="white" opacity="0.95"></path></svg> --> */}
          <img src="./images/annadanam.png" alt="Online Booking" Style={{width:'100%'}} />
        </div>
         <h6 style={{color:'maroon',zIndex:'999',fontWeight:'600'}}>Prathishta 10</h6>
        <div class="label" id="title-1" style={{color:'white'}}>View</div>
        {/* <span class="sr-only">Discover — Align on problems</span> */}
        
      </article>
      </Link>

      {/* <!-- 7 --> */}
      <Link to="https://booking.sreepadmanabhaswamytemple.org/onavill/Default.aspx">
      <article class="card" tabindex="0" aria-labelledby="title-1">
        
        <div class="ring" aria-hidden></div>
        <div class="spark one" aria-hidden></div>
        <div class="icon-wrap_" aria-hidden>
          {/* <!-- compass --> */}
          {/* <!-- <svg viewBox="0 0 24 24" fill="none" aria-hidden><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z" stroke="white" stroke-width="1.2" opacity="0.9"></path><path d="M9 15l6-3-3-6-6 3 3 6z" fill="white" opacity="0.95"></path></svg> --> */}
          <img src="./images/onavillu.png" alt="onavillu Booking" Style={{width:'100%'}} />
        </div>
         <h6 style={{color:'maroon',zIndex:'999',fontWeight:'600'}}>Prathishta 11</h6>
        <div class="label" id="title-1" style={{color:'white'}}>Book</div>
        {/* <span class="sr-only">Discover — Align on problems</span> */}
        
      </article>
      </Link>

      {/* <!-- 8 --> */}
       <Link to="/Accommodation">
      <article class="card" tabindex="0" aria-labelledby="title-1">
        
        <div class="ring" aria-hidden></div>
        <div class="spark one" aria-hidden></div>
        <div class="icon-wrap_" aria-hidden>
          {/* <!-- compass --> */}
          {/* <!-- <svg viewBox="0 0 24 24" fill="none" aria-hidden><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z" stroke="white" stroke-width="1.2" opacity="0.9"></path><path d="M9 15l6-3-3-6-6 3 3 6z" fill="white" opacity="0.95"></path></svg> --> */}
          <img src="./images/accommodation.png" alt="Online Booking" Style={{width:'100%'}} />
        </div>
         <h6 style={{color:'maroon',zIndex:'999',fontWeight:'600'}}>Prathishta 12</h6>
        <div class="label" id="title-1" style={{color:'white'}}>View</div>
        {/* <span class="sr-only">Discover — Align on problems</span> */}
        
      </article>
      </Link>

    </section>
  </main>


  );
}

export default Booking;












